/* eslint-disable @typescript-eslint/no-explicit-any */
import { Group, FabricImage, Textbox } from 'fabric';

import { useCanvasStore } from '../store';

import { MenuItemWithBackup } from '../types/types';

import { deleteMaskImage } from './crop';

import { isUserImage } from './imageUtils';
import { isBullet, isBulletTextItem, performActionOnObjectInGroup } from './groupUtils';

export const deleteItems = ({
  targetIds,
  canvas,
  canvasId,
  addBackup,
}: Omit<MenuItemWithBackup, 'item'>) => {
  const idsToDelete = Array.isArray(targetIds) ? targetIds : [targetIds];
  const activeObjects = canvas.getActiveObjects();
  let isContentChanged = false; // Flag for tracking content changes (text, image, bullet item)

  idsToDelete.forEach((currentId) => {
    const targetObject = canvas.getObjects().find((object) => {
      if (object.id === currentId) {
        return true;
      } else if (object.category) {
        // If the object to delete is in a group (bullets)
        if (isBullet(object) && object instanceof Group) {
          performActionOnObjectInGroup(object, currentId, (obj) => {
            object.remove(obj); // Remove object from group
          });
          return; // Object found and processed
        }
      }
    });

    // Check if the object is a text, user-image or bullet item
    if (targetObject) {
      if (
        targetObject instanceof Textbox ||
        targetObject.type?.toLowerCase() === 'textbox' ||
        targetObject instanceof FabricImage ||
        isUserImage(targetObject) ||
        isBullet(targetObject) ||
        isBulletTextItem(targetObject)
      ) {
        isContentChanged = true; // Set flag isChangedContent
      }

      if (
        targetObject &&
        targetObject.category !== undefined &&
        targetObject.category !== null &&
        targetObject.type.toLowerCase() === 'image' &&
        targetObject.category.toLowerCase() === 'crop'
      ) {
        const imageObject = targetObject as FabricImage;
        deleteMaskImage(canvas, imageObject);
      }

      const activeCanvasId = useCanvasStore.getState().activeCanvasId;
      if (activeCanvasId) {
        useCanvasStore.getState().removeLayerObject(activeCanvasId, targetObject.layer, {
          object: targetObject,
          zIndex: targetObject.zIndex,
          layer: targetObject.layer,
        });
      }
      canvas.remove(targetObject);
    }
  });

  if (activeObjects.length > 0) {
    canvas.discardActiveObject();
  }

  const cfg = canvas.toJSON();

  // Set flag isChangedContent, if content was deleted (text, image, bullet item)
  if (isContentChanged) {
    cfg.isChangedContent = true; // Need for backend for layouts
  }

  addBackup(canvasId, cfg);
  canvas.requestRenderAll();
  // loadObjectsWithLayers(canvasId, cfg);
};
